import {Domain} from 'shared';


export class UserDomain extends Domain {
  total_area?: number;
}
